import { ArrowRight, CalendarDays, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { deadlineLabel, formatCurrency, progressPercentage } from "@/lib/goals";

export const GoalCard = ({ goal }) => {
  const progress = progressPercentage(goal);
  const status = goal.status === "scheduled" && goal.scheduled_for
    ? `Começa em ${new Date(`${goal.scheduled_for}T12:00:00`).toLocaleDateString("pt-BR")}`
    : goal.is_complete ? "Concluída" : "Em andamento";

  return (
    <li
      data-testid={`goal-card-${goal.id}`}
      className="rounded-2xl border border-amber-200 bg-white p-5 shadow-sm"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-bold uppercase tracking-wide text-amber-800">
            {status}
          </p>
          <h3 data-testid={`goal-title-${goal.id}`} className="mt-1 font-heading text-2xl font-extrabold text-emerald-950">
            {goal.title}
          </h3>
        </div>
        {goal.is_complete && <CheckCircle2 className="h-7 w-7 shrink-0 text-emerald-600" />}
      </div>
      <p data-testid={`goal-amount-${goal.id}`} className="mt-4 text-xl font-bold text-slate-800">
        {formatCurrency(goal.amount_cents)}
      </p>
      <div className="mt-4 h-3 overflow-hidden rounded-full bg-amber-100" aria-hidden="true">
        <div className="h-full rounded-full bg-emerald-600 transition-[width] duration-300" style={{ width: `${progress}%` }} />
      </div>
      <p data-testid={`goal-progress-${goal.id}`} className="mt-2 text-base font-semibold text-slate-600">
        {formatCurrency(goal.saved_cents)} guardados · {progress}%
      </p>
      <p data-testid={`goal-deadline-${goal.id}`} className="mt-3 flex items-center gap-2 text-base text-slate-600">
        <CalendarDays className="h-4 w-4 text-amber-700" /> {deadlineLabel(goal)}
      </p>
      <Link
        to={`/metas/${goal.id}`}
        data-testid={`open-goal-${goal.id}-link`}
        className="mt-5 inline-flex min-h-[46px] items-center gap-2 rounded-xl px-3 text-lg font-bold text-emerald-800 transition-colors hover:bg-emerald-50"
      >
        Abrir cofrinho <ArrowRight className="h-5 w-5" />
      </Link>
    </li>
  );
};